import { RoutesApiConst } from "../constants";
import { IProfileDto } from "../dto";
import { Api } from "../helpers";

export class ProfileApi {
  static async getProfile(): Promise<IProfileDto | undefined> {
    const response = await Api.get<IProfileDto>(RoutesApiConst.profile.fetch);

    return response?.data;
  }

  static async update(
    payload: Partial<IProfileDto>,
  ): Promise<IProfileDto | undefined> {
    const response = await Api.patch<IProfileDto>(
      RoutesApiConst.profile.update,
      payload,
    );

    return response?.data;
  }
}
